module.exports = __webpack_public_path__ + "static/media/Kalispell Branch location.f2a6b0f4.png";